var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNewFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "103.9%",
    cy: "-10.387%",
    fx: "103.9%",
    fy: "-10.387%",
    r: "166.816%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84D70",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A337F6",
    offset: "53.089%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A7ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M30.343 36v-5.834h5.686v-4.302h-5.686V20h-4.597v5.864H20v4.302h5.746V36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewFeedback);
export default __webpack_public_path__ + "static/media/icon-new-feedback.de9414c7e4310cc4d4d562f2953c3da5.svg";
export { ForwardRef as ReactComponent };